<template>
<div>
  <div class="footer-area response ">
    <div class="marginauto text-white boty">
      
      
      <div class="">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="f_left">
              <div class="left_title pointer">
                联系我们
              </div>
    
              <div class="right_text pointer">
                联系电话：010-85964500
              </div>
              <div class="right_text pointer">
                联系地址：北京市朝阳区慈云寺1号院3号楼 一层二层 八里庄孵化器3-0367号
              </div>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="f_right">
              <div class="pointer right_title pointer">友情链接</div>
              <div style="display: flex;width: 100%;flex-wrap: wrap;">
                <div v-for="(item,index) in list" :key="index" class="tttt">
                    <div class="text-cut right_text pointer" @click="toout(item.url)">{{item.name}}</div>
                  </div>
              </div>
            </div>
          </el-col>
        </el-row>
        
      </div>
      <div class="horline"></div>
      <div class="flex justify-between align-center text-four bcolor">
        <div class="pointer" @click="toout('http://www.harborn.cn')">Copyright © 2022 北京嘉博环球教育科技有限公司 | 主办方：北京嘉博环球教育科技有限公司</div>
        <div class="pointer" @click="toout('http://www.harborn.cn')">技术支持：北京嘉博环球教育科技有限公司</div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'footer',
  data(){
    return{
      // list:[
      //   '国家粮食和物资储备局','中储粮','中华粮网','北京大学经济学院','对外经济贸易大学','首都经济贸易大学','厦门大学国际经济与贸易系','中国高等教育学生信息网(学信网)','中国研究生招生信息网','河南省学生资助网','应届毕业网','挑战杯 全国大学生课外学'
      // ],
      list:[{
        name: '中国地震局',
        url: 'https://www.cea.gov.cn/'
      },{
        name: '中国地震灾害防御中心',
        url: 'https://www.eq-cedpc.cn/index'
      },{
        name: '中国地震局地震预测研究所',
        url: 'https://www.ief.ac.cn/'
      },{
        name: '国际地震中心（ISC）',
        url: 'http://www.isc.ac.uk/'
      },{
        name: '国际地震学与地球内部物理学联合会（IASPEI）',
        url: 'https://www.cea.gov.cn/'
      },{
        name: '中华人民共和国应急管理部',
        url: 'http://www.mem.gov.cn/'
      },{
        name: '中华人民共和国水利部',
        url: 'http://www.mwr.gov.cn/'
      },{
        name: '中华人民共和国生态环境部',
        url: 'https://www.mee.gov.cn/hjzl/'
      },{
        name: '国家气象科学数据中心',
        url: 'http://data.cma.cn/'
      },{
        name: '国家林业和草原局',
        url: 'http://www.forestry.gov.cn/'
      }],
      config: ''
    }
  },
  methods:{
    getlink(){
      this.$api.user.getlinks().then(res=>{
        // console.log()
        this.list = res.data;
      })
    },
    toout(href){
      window.open(href)
    },
    getconfig(){
      this.$api.index.config().then(response => {
        // this.list = response.data.items
        // console.log(response)
        this.config = response.data;
        var s = JSON.stringify(response.data)
        localStorage.setItem('config', s)
      })
    },
  },
  created(){
    // this.getconfig();
    // this.getlink();
  }
}
</script>

<style scoped>
  .conone:hover{
    color: #006bef;
  }
  .tttt{
    margin-right:15px;
  }
  .tttt:last-child{
    margin-right: 0;
  }
  .left_title{
    color: #ffffff;
  }
  .footer-area{
    background: url('../assets/images/shock/2.png');
    background-size: 100% 100%;
  }
</style>


// WEBPACK FOOTER //
// footer.vue?07af7882